//  Safe JSON parse function
export const safeJSONParse = (jsonString, defaultValue = {}) => {
  try {
    return JSON.parse(jsonString) || defaultValue;
  } catch (error) {
    console.error('Error parsing JSON:', error);
    return defaultValue; // Return default value on error
  }
};
